import React from 'react';

import AdminCardOrderField from '../admin-card-fields/AdminCardOrderField/AdminCardOrderField';
import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminServiceCard.css';

const AdminServiceCard = ({
  service,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const serviceFields = [
    { label: 'Title:', value: service.title, type: 'text' },
    { label: 'Description:', value: service.description, type: 'textarea' },
    { label: 'Booking Link:', value: service.janeUrl, type: 'url' },
    {
      label: 'Show on Services Page:',
      value: service.showOnServices,
      type: 'checkbox',
    },
  ];

  const homeServiceFields = [
    {
      label: 'Description Title \n(if different from Title for Services Page):',
      value: service.homeTitle,
      type: 'text',
    },
    { label: 'Description:', value: service.homeDescription, type: 'textarea' },
    {
      label:
        'Booking Link \n(if different from Booking Link for Services Page):',
      value: service.homeJaneUrl,
      type: 'url',
    },
    {
      label: 'Label \n(if different from Title for Services Page):',
      value: service.homeLabel,
      type: 'text',
    },
    {
      label: 'Show on Home Page:',
      value: service.showOnHome,
      type: 'checkbox',
    },
  ];

  return (
    <div className='services__list'>
      <div className='admin-service-card-top-container'>
        <AdminCardOrderField>{service?.order}</AdminCardOrderField>
        <div className='admin-service-edit-delete-button-container'>
          <ContentChangeButton
            iconType='edit'
            onClickHandler={() => onEditClickHandler(service)}
          />
          <ContentChangeButton
            iconType='delete'
            onClickHandler={() => onDeleteClickHandler(service)}
          />
        </div>
      </div>
      <div className='admin-content-container'>
        <div className='admin-services-page-container'>
          <h3 className='admin-service-page-title'>Services Page</h3>
          <AdminCardImage size='large' img={service.imageUrl} />
          <div className='services-fields-container'>
            {serviceFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>
        <div className='admin-services-home-container'>
          <h3 className='admin-service-page-title'>Home Page</h3>
          <AdminCardImage
            size='large'
            img={service.homeImageUrl}
            noImgMsg={
              '(Upload a photo if different from the photo for Services Page)'
            }
          />
          <div className='services-fields-container'>
            {homeServiceFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminServiceCard;
